<template>
  <van-collapse v-model="activeFirst" class="top">
    <van-collapse-item  name="1" class="index-top-title">
      <template #title>
        <div class="top-logo-class">
          <van-image :src="require('@/assets/img/index/logo.png')"  class="index-logo"/>
        </div>
      </template>
      <van-collapse v-model="activeSecond" accordion>
        <van-collapse-item title="关于GERM" name="1">
          <template #right-icon>
            <div v-if="activeSecond == 1">
              <van-icon name="cross"/>
            </div>
            <!-- 关闭时的图标 -->
            <div v-else>
              <van-icon name="plus"/>
            </div>
          </template>
          <van-cell title="品牌形象大使" :to="{path: '/',query:{mIndex:1,bIndex:0}}" />
          <van-cell title="品牌故事" :to="{path: '/',query:{mIndex:1,bIndex:1}}" />
          <van-cell title="定位 愿景 使命" :to="{path: '/',query:{mIndex:1,bIndex:2}}" />
          <van-cell title="用户画像" :to="{path: '/',query:{mIndex:1,bIndex:3}}" />
          <van-cell title="品牌历程" :to="{path: '/',query:{mIndex:1,bIndex:4}}" />
          <van-cell title="全球化战略" :to="{path: '/',query:{mIndex:1,bIndex:5}}" />
        </van-collapse-item>
        <van-collapse-item title="潮流趋势" name="2" class="index-border-top">
          <template #right-icon>
            <div v-if="activeSecond == 2">
              <van-icon name="cross"/>
            </div>
            <!-- 关闭时的图标 -->
            <div v-else>
              <van-icon name="plus"/>
            </div>
          </template>
          <van-cell title="2023FESTIVAL/WINTER" :to="{path: '/about',query:{mIndex:2,zIndex:0}}" />
          <van-cell title="2023SPRING/SUMMER" :to="{path: '/about',query:{mIndex:2,zIndex:1}}" />
          <van-cell title="2022FESTIVAL/WINTER" :to="{path: '/about',query:{mIndex:2,zIndex:2}}"/>
          <van-cell title="2022SPRING/SUMMER" :to="{path: '/about',query:{mIndex:2,zIndex:3}}"/>
          <van-cell title="潮童出行" :to="{path: '/about',query:{mIndex:2,zIndex:4}}"/>

        </van-collapse-item>
        <van-cell title="资讯速递" class="index-border-top" :to="{path: '/about',query:{mIndex:3}}">
          <!-- 面板1的内容 -->
        </van-cell>
        <van-cell title="找到我们"  class="index-border-top" :to="{path: '/about',query:{mIndex:4}}">
          <!-- 面板2的内容 -->
        </van-cell>
        <van-cell  class="index-border-top">
          <van-row class="top-link-logo">
            <van-col span="4" @click="showQrCodePopup('tb')">
              <van-image  :src="require('@/assets/img/index/tb.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('wx')">
              <van-image  :src="require('@/assets/img/index/wx.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('wb')">
              <van-image  :src="require('@/assets/img/index/wb.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('xhs')">
              <van-image  :src="require('@/assets/img/index/xhs.png')"/>
            </van-col>
            <van-col span="4" offset="1" @click="showQrCodePopup('dy')">
              <van-image  :src="require('@/assets/img/index/dy.png')"/>
            </van-col>
          </van-row>
        </van-cell>
      </van-collapse>
    </van-collapse-item>
  </van-collapse>
<!--  <van-nav-bar-->
<!--      :title="title"-->
<!--      left-arrow-->
<!--      @click-left="onClickLeft"-->
<!--  />-->
  <van-swipe class="my-swipe product-banner"  :autoplay="3000" :show-indicators="false">
    <van-swipe-item v-for="(item, index) in guntu" :key="index">
      <img v-lazy="item" alt="banner">
    </van-swipe-item>
  </van-swipe>
  <van-row class="product-list">
    <van-col span="12"  v-for="(product, index) in pdc_data" :key="index" ref="itemRefs">
      <img max-width="50%" ref="myImg" height="215"  v-lazy="product.p_url"/>
      <van-cell :title="product.season" class="prodcut-season" />
      <van-cell :title="product.brand"  />
      <van-cell :title="product.name">
        <van-row class="co-list">
          <van-col class="prodcut-color" span="3"  v-for="(color, co_index) in product.color_list"
                   :key="co_index"
                   ref="itemRef"
                   :class="{ 'color-active': co_index === product.selectColor}"
                   @click="toggleImage(index,co_index,product)">
            <van-image :style="{width:'11px',height:'11px'}" lazy-load :src="color" />
          </van-col>
        </van-row>
      </van-cell>
    </van-col>
  </van-row>
  <van-divider :hairline="false" :style="{padding:'0 20px',borderColor:'#000' }" />
  <van-row justify="center" class="botton-msg">
    <van-col span="24" :style="{textAlign:'center'}">以先锐产品创意注入设计之中<br />
      作为未来潮奢生活的预演，向着杯壶世界无限延伸<br />潮不逐流，创造从不设限，这一季，属于热爱的流派</van-col>
  </van-row>

</template>
<script>
import { Swipe, SwipeItem,Cell,Popup,Icon,Collapse, CollapseItem,Col, Row,Image,Space,Divider,NavBar,Lazyload} from 'vant';
// import { ref } from 'vue';

export default {
  components:{
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem,
    [Cell.name]:Cell,
    [Popup.name]:Popup,
    [Icon.name]:Icon,
    [Collapse.name]:Collapse,
    [CollapseItem.name]:CollapseItem,
    [Col.name]:Col,
    [Row.name]:Row,
    [Image.name]:Image,
    [Space.name]:Space,
    [Divider.name]:Divider,
    [NavBar.name]:NavBar,
    [Lazyload.name]:Lazyload,
  },

  data(){
    return{
      screenHeight:896,
      activeFirst: [],
      activeSecond: 0,
      productData: {
        1:{
          1:{
            p_url: require('@/assets/img/product/p1_1.png'),
            color_list: [
              require('@/assets/img/product/c1_1.png'),
              require('@/assets/img/product/c1_2.png'),
            ],
            season: '2023秋冬新品',
            brand: '可口可乐联名款',
            name: '律动保温杯',
            selectColor:0,
          },
          2: {
            p_url: require('@/assets/img/product/p2_1.png'),
            color_list: [
              require('@/assets/img/product/c2_1.png'),
              require('@/assets/img/product/c2_2.png'),
              require('@/assets/img/product/c2_3.png'),
              require('@/assets/img/product/c2_4.png'),
            ],
            season: '2023秋冬新品',
            brand: '可口可乐联名款',
            name: '元气运动保温杯',
            selectColor:0,
          },
          3: {
            p_url: require('@/assets/img/product/p3_1.png'),
            color_list: [
              require('@/assets/img/product/c3_1.png'),
              require('@/assets/img/product/c3_2.png'),
              require('@/assets/img/product/c3_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '可口可乐联名款',
            name: '徽章系列保温杯',
            selectColor:0,
          },
          4: {
            p_url: require('@/assets/img/product/p4_1.png'),
            color_list: [
              require('@/assets/img/product/c4_1.png'),
              require('@/assets/img/product/c4_2.png'),
            ],
            season: '2023秋冬新品',
            brand: '可口可乐联名款',
            name: '揽萃保温杯',
            selectColor:0,
          },
          5: {
            p_url: require('@/assets/img/product/p5_1.png'),
            color_list: [
              require('@/assets/img/product/c5_1.png'),
              require('@/assets/img/product/c5_2.png'),
              require('@/assets/img/product/c5_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '米奇唐老鸭系列',
            name: '轻氧运动保温杯',
            selectColor:0,
          },
          6: {
            p_url: require('@/assets/img/product/p6_1.png'),
            color_list: [
              require('@/assets/img/product/c6_1.png'),
              require('@/assets/img/product/c6_2.png'),
            ],
            season: '2023秋冬新品',
            brand: '草莓熊系列',
            name: '彩虹星球保温杯',
            selectColor:0,
          },
          7: {
            p_url: require('@/assets/img/product/p7_1.png'),
            color_list: [
              require('@/assets/img/product/c7_1.png'),
              require('@/assets/img/product/c7_2.png'),
              require('@/assets/img/product/c7_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '迪士尼米奇系列',
            name: '萌耳保温杯',
            selectColor:0,
          },
          8: {
            p_url: require('@/assets/img/product/p8_1.png'),
            color_list: [
              require('@/assets/img/product/c8_1.png'),
              require('@/assets/img/product/c8_2.png'),
              require('@/assets/img/product/c8_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '奥特曼系列',
            name: '超能保温杯',
            selectColor:0,
          },
          9: {
            p_url: require('@/assets/img/product/p9_1.png'),
            color_list: [
              require('@/assets/img/product/c9_1.png'),
            ],
            season: '2023秋冬新品',
            brand: '大都会-GERM×THE MET绮梦宝境系列',
            name: '闪耀咖啡杯',
            selectColor:0,
          },
          10: {
            p_url: require('@/assets/img/product/p10_1.png'),
            color_list: [
              require('@/assets/img/product/c10_1.png'),
              require('@/assets/img/product/c10_2.png'),
            ],
            season: '2023秋冬新品',
            brand: '大都会-GERM×THE MET绮梦宝境系列',
            name: '菱形咖啡杯',
            selectColor:0,
          },
          11: {
            p_url: require('@/assets/img/product/p11_1.png'),
            color_list: [
              require('@/assets/img/product/c11_1.png'),
              require('@/assets/img/product/c11_2.png'),
              require('@/assets/img/product/c11_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '王者荣耀系列',
            name: '菱形咖啡杯',
            selectColor:0,
          },
          12: {
            p_url: require('@/assets/img/product/p12_1.png'),
            color_list: [
              require('@/assets/img/product/c12_1.png'),
              require('@/assets/img/product/c12_2.png'),
            ],
            season: '2023秋冬新品',
            brand: 'GERM格沵',
            name: '天使7号保温杯',
            selectColor:0,
          },
        },
        5:{
          1:{
            p_url: require('@/assets/img/product/5/p1_1.png'),
            color_list: [
              require('@/assets/img/product/5/c1_1.png'),
              require('@/assets/img/product/5/c1_2.png'),
            ],
            season: '2023秋冬新品',
            brand: 'GERM格沵',
            name: '梦旅者儿童护脊书包',
            selectColor:0,
          },
          2: {
            p_url: require('@/assets/img/product/5/p2_1.png'),
            color_list: [
              require('@/assets/img/product/5/c2_1.png'),
              require('@/assets/img/product/5/c2_2.png'),
              require('@/assets/img/product/5/c2_3.png'),
            ],
            season: '2023秋冬新品',
            brand: '奥特曼系列',
            name: '光线儿童出行包',
            selectColor:0,
          },
          3: {
            p_url: require('@/assets/img/product/5/p3_1.png'),
            color_list: [
              require('@/assets/img/product/5/c3_1.png'),
            ],
            season: '2023秋冬新品',
            brand: '奥特曼系列',
            name: '守护宇宙旅行包',
            selectColor:0,
          },
          4: {
            p_url: require('@/assets/img/product/5/p4_1.png'),
            color_list: [
              require('@/assets/img/product/5/c4_1.png'),
              require('@/assets/img/product/5/c4_2.png'),
            ],
            season: '2023秋冬新品',
            brand: 'GERM格沵',
            name: '趴趴熊斜跨包',
            selectColor:0,
          },
          5: {
            p_url: require('@/assets/img/product/5/p5_1.png'),
            color_list: [
              require('@/assets/img/product/5/c5_1.png'),
              require('@/assets/img/product/5/c5_2.png'),
              require('@/assets/img/product/5/c5_3.png'),
            ],
            season: '2023秋冬新品',
            brand: 'GREM格沵',
            name: '发光熊斜挎包',
            selectColor:0,
          },
        }
      },
      guntuData:{
        1:[
          require('@/assets/img/product/g1_1.png'),
          require('@/assets/img/product/g1_2.png'),
          require('@/assets/img/product/g1_3.png'),
          require('@/assets/img/product/g1_4.png'),
          require('@/assets/img/product/g1_5.png'),
          require('@/assets/img/product/g1_6.png'),
          require('@/assets/img/product/g1_7.png'),
          require('@/assets/img/product/g1_8.png'),
          require('@/assets/img/product/g1_9.png'),
        ],
        5:[
          require('@/assets/img/product/g5_1.png'),
          require('@/assets/img/product/g5_2.png'),
          require('@/assets/img/product/g5_3.png'),
          require('@/assets/img/product/g5_4.png'),
          require('@/assets/img/product/g5_5.png'),
          require('@/assets/img/product/g5_6.png'),
          require('@/assets/img/product/g5_7.png'),
          require('@/assets/img/product/g5_8.png'),
          require('@/assets/img/product/g5_9.png'),
        ],
      },
      productList:{
       1:{
         1:[require('@/assets/img/product/p1_1.png'),require('@/assets/img/product/p1_2.png')],
         2:[require('@/assets/img/product/p2_1.png'),require('@/assets/img/product/p2_2.png'),
           require('@/assets/img/product/p2_3.png'),require('@/assets/img/product/p2_4.png')],
         3:[require('@/assets/img/product/p3_1.png'),require('@/assets/img/product/p3_2.png'),
           require('@/assets/img/product/p3_3.png')],
         4:[require('@/assets/img/product/p4_1.png'),require('@/assets/img/product/p4_2.png')],
         5:[require('@/assets/img/product/p5_1.png'),require('@/assets/img/product/p5_2.png'),
           require('@/assets/img/product/p5_3.png')],
         6:[require('@/assets/img/product/p6_1.png'),require('@/assets/img/product/p6_2.png')],
         7:[require('@/assets/img/product/p7_1.png'),require('@/assets/img/product/p7_2.png'),
           require('@/assets/img/product/p7_3.png')],
         8:[require('@/assets/img/product/p8_1.png'),require('@/assets/img/product/p8_2.png'),
           require('@/assets/img/product/p8_3.png')],
         9:[require('@/assets/img/product/p9_1.png')],
         10:[require('@/assets/img/product/p10_1.png'),require('@/assets/img/product/p10_2.png')],
         11:[require('@/assets/img/product/p11_1.png'),require('@/assets/img/product/p11_2.png'),
           require('@/assets/img/product/p11_3.png')],
         12:[require('@/assets/img/product/p12_1.png'),require('@/assets/img/product/p12_2.png')],
       },
       5:{
         1:[require('@/assets/img/product/5/p1_1.png'),require('@/assets/img/product/5/p1_2.png')],
         2:[require('@/assets/img/product/5/p2_1.png'),require('@/assets/img/product/5/p2_2.png'),
           require('@/assets/img/product/5/p2_3.png')],
         3:[require('@/assets/img/product/5/p3_1.png')],
         4:[require('@/assets/img/product/5/p4_1.png'),require('@/assets/img/product/5/p4_2.png')],
         5:[require('@/assets/img/product/5/p5_1.png'),require('@/assets/img/product/5/p5_2.png'),
           require('@/assets/img/product/5/p5_3.png')],
       },
      },
      colorList:[
          []

      ],
      product:[],
      guntu:[],
      pdc_data:[],
      // titleList:{
      //   1:'2023FESTIVAL/WINTER 2023秋冬新品系列',
      //   5:'2023STYLISH KIDS\' TRAVEL 儿童出行系列'
      // },
      // title:'',
    }
  },
  mounted() {
    // 获取参数
    const pid = this.$route.query.pid;
    this.product = this.productList[pid];
    this.guntu = this.guntuData[pid];
    this.pdc_data = this.productData[pid];
    //this.title = this.titleList[pid];

  },
  created() {
    this.getScreenHeight();
  },
  methods: {
    getScreenHeight() {
      this.screenHeight = window.innerHeight -44;
    },
    // onSwiperChange(currentIndex) {
    //   // 在 Swiper 切换到新的轮播项时触发
    //   console.log(currentIndex);
    // },
    handleClickOutside() {// 收起折叠面板
      if (this.activeFirst.length > 0 ) {
        this.activeFirst = [];
      }
    },
    onClickLeft(){
      this.$router.push({
        path: '/about',
        query: { mIndex: 2, zIndex:4}
      });
      // history.back();
    },
    toggleImage(index,co_index,product){
      const node = this.$refs.myImg[index-1]
      node.src = this.product[index][co_index];
      product.selectColor = co_index;
    }
  },
}
</script>
<style>
body{
  background: #FFF;
  font-family: OPPOSans;
}
.product-banner .van-image{
  display: block;
}
.product-title{
  font-family: OPPOSans;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #000000;
}
.product-list .van-col .van-cell{
  padding: 0 0;
  line-height: 22px;
  font-size: 12px;
}
.product-list .van-col .van-cell__title{
  text-align: left;
  padding-left: 8px;
}
.botton-msg{
  font-size: 16px;
  font-weight: normal;
  line-height: 26px;
  text-align: center;
  letter-spacing: -0.03em;
  font-feature-settings: "kern" on;
  color: #1D1D1D;
  margin-bottom: 50px;
}
/*.product-list .van-col--12{*/
/*  text-align: center;*/
/*  height: 302px;*/
/*  line-height: 215px;*/
/*}*/

.product-banner .van-swipe-item {
  color: #fff;
  font-size: 20px;
  height: 538px;
  line-height: 538px;
  text-align: center;
  overflow: hidden;
}
 .product-banner .van-swipe-item img{
  width:430px;
  height: 538px;
}

 .van-collapse-item__content .van-cell:after{
  border-top: 0;
}
.van-collapse-item__title--expanded:after{
  display: none;
}
 .van-collapse-item:nth-child(2){
  border-bottom: 0.0625rem solid var(--van-cell-border-color);
}
.van-nav-bar__title{
  margin-left: 45px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0em;
  color: #000000;
}
.van-nav-bar__content{
  height: 46px;
}
.van-nav-bar .van-icon{
  color: #000;
}
.prodcut-color{
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}
.co-list{
  justify-content: flex-end;
}
.prodcut-color{
  margin: 0 6px;
  padding-top: 4px;
  padding-bottom: 2px;
}
.color-active{
  border-bottom: 1px solid #000;
}
/*.index-top-title .van-cell--clickable:not(.van-collapse-item__wrapper .van-cell--clickable){*/
/*  padding-bottom: 0px;*/
/*  padding-left: 28px;*/
/*  padding-right: 28px;*/
/*  position: fixed;*/
/*  z-index: 100;*/
/*}*/
.index-logo img{
  width: 96px;
  height: 35px;
}
.top [class*=van-hairline]:after{
  border:0;
}
.top .van-collapse-item__content{
  padding-bottom: 0px;
}
.top .top-link-logo img{
  width: 53px;
  height: 25px;
}
.top .van-icon-arrow:before{
  font-size: 35px;
  padding-top: 10px;
  color: #000;
}
.product-list .van-cell:after{
  border-bottom: none;
}
.product-list .prodcut-season{
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  color: #787878;
}
</style>
